export const UI_SET_LOADER = 'UI_SET_LOADER';
export const UI_SET_LOADER_TEXT = 'UI_SET_LOADER_TEXT';
export const SET_UI_PROPERTY = 'SET_UI_PROPERTY';
export const GET_MARKDOWN_FILE = 'GET_MARKDOWN_FILE';
export const UI_UPDATE_FROM_PARTNER = 'UI_UPDATE_FROM_PARTNER';
export const UI_GET_TOWNS_BY_CP = 'UI_GET_TOWNS_BY_CP';
export const UI_UPDATE_TOWNS_BY_CP_CACHE = 'UI_UPDATE_TOWNS_BY_CP_CACHE';
export const UI_GET_MASTER_DATA = 'UI_GET_MASTER_DATA';
export const UI_UPDATE_MASTER_DATA = 'UI_UPDATE_MASTER_DATA';
export const GET_PARTNER_DATA = 'GET_PARTNER_DATA';
export const SET_PARTNER_DATA = 'SET_PARTNER_DATA';
export const GET_PARTNER_DATA_BY_TRANSACTION_ID = 'GET_PARTNER_DATA_BY_TRANSACTION_ID';
export const UI_SET_MENU = 'UI_SET_MENU';
export const UI_SET_NOTIFICATIONS_MENU = 'UI_SET_NOTIFICATIONS_MENU';
export const UI_GET_DOCUMENTATION_MASTERDATA = 'UI_GET_DOCUMENTATION_MASTERDATA';
export const UI_GET_REMPLACEMENT_VEHICLE_MASTERDATA = 'UI_GET_REMPLACEMENT_VEHICLE_MASTERDATA';
